(function () {
  function moneyText(value) {
    if (window.Shopify && typeof window.Shopify.formatMoney === "function") {
      return window.Shopify.formatMoney(value);
    }
    return "$" + (Number(value || 0) / 100).toFixed(2);
  }

  function initHeader() {
    var toggle = document.querySelector(".qol-mobile-toggle");
    var menu = document.getElementById("QolMobileMenu");
    if (toggle && menu) {
      toggle.addEventListener("click", function () {
        var open = toggle.getAttribute("aria-expanded") === "true";
        toggle.setAttribute("aria-expanded", String(!open));
        menu.hidden = open;
      });
    }

    document.querySelectorAll(".qol-nav__button").forEach(function (button) {
      button.addEventListener("click", function () {
        var item = button.closest(".qol-nav__item");
        var open = item.classList.toggle("is-open");
        button.setAttribute("aria-expanded", String(open));
      });
    });
  }

  function initGallery(root) {
    var slides = root.querySelectorAll("[data-gallery-slide]");
    var thumbs = root.querySelectorAll("[data-gallery-thumb]");
    if (!slides.length || !thumbs.length) return;

    function show(index) {
      slides.forEach(function (slide) {
        slide.classList.toggle("is-active", slide.getAttribute("data-gallery-slide") === String(index));
      });
      thumbs.forEach(function (thumb) {
        thumb.classList.toggle("is-active", thumb.getAttribute("data-gallery-thumb") === String(index));
      });
    }

    thumbs.forEach(function (thumb) {
      thumb.addEventListener("click", function () {
        show(thumb.getAttribute("data-gallery-thumb"));
      });
    });
  }

  function initQuantity(root) {
    var input = root.querySelector("[data-quantity-input]");
    if (!input) return;
    var plus = root.querySelector("[data-qty-plus]");
    var minus = root.querySelector("[data-qty-minus]");
    var clamp = function (value) { return Math.max(1, parseInt(value || "1", 10)); };

    if (plus) plus.addEventListener("click", function () { input.value = clamp(input.value) + 1; });
    if (minus) minus.addEventListener("click", function () { input.value = Math.max(1, clamp(input.value) - 1); });
    input.addEventListener("change", function () { input.value = clamp(input.value); });
  }

  function initPurchaseBox(root) {
    var purchaseBox = root.querySelector("[data-purchase-box]");
    if (!purchaseBox) return;
    var labels = purchaseBox.querySelectorAll("[data-purchase-option]");
    var sellingPlanWrap = purchaseBox.querySelector("[data-selling-plan-wrap]");
    var sellingPlanSelect = purchaseBox.querySelector("[data-selling-plan-select]");
    var fixedSelect = document.querySelector("[data-fixed-plan-select]");

    function setMode(mode) {
      labels.forEach(function (label) {
        var active = label.getAttribute("data-purchase-option") === mode;
        label.classList.toggle("is-selected", active);
        var radio = label.querySelector("input[type='radio']");
        if (radio) radio.checked = active;
      });
      if (sellingPlanWrap) sellingPlanWrap.classList.toggle("is-visible", mode === "subscription");
      if (sellingPlanSelect && mode === "onetime") {
        sellingPlanSelect.dataset.cachedPlan = sellingPlanSelect.value;
        sellingPlanSelect.value = "";
      } else if (sellingPlanSelect && sellingPlanSelect.dataset.cachedPlan) {
        sellingPlanSelect.value = sellingPlanSelect.dataset.cachedPlan;
      }
      if (fixedSelect) {
        fixedSelect.value = mode === "onetime" ? "onetime" : (sellingPlanSelect ? sellingPlanSelect.value : "");
      }
    }

    labels.forEach(function (label) {
      label.addEventListener("click", function () {
        setMode(label.getAttribute("data-purchase-option"));
      });
    });
    if (fixedSelect) {
      fixedSelect.addEventListener("change", function () {
        if (fixedSelect.value === "onetime") {
          setMode("onetime");
        } else {
          setMode("subscription");
          if (sellingPlanSelect) sellingPlanSelect.value = fixedSelect.value;
        }
      });
    }
    var selectedLabel = purchaseBox.querySelector("[data-purchase-option].is-selected");
    setMode(selectedLabel ? selectedLabel.getAttribute("data-purchase-option") : "subscription");
  }

  function initAccordions(scope) {
    scope.querySelectorAll("[data-accordion-group]").forEach(function (group) {
      group.addEventListener("click", function (event) {
        var button = event.target.closest(".qol-accordion-title, .qol-faq-title");
        if (!button || !group.contains(button)) return;
        var panel = button.nextElementSibling;
        var willOpen = !button.classList.contains("is-active");

        if (button.classList.contains("qol-accordion-title")) {
          group.querySelectorAll(".qol-accordion-title").forEach(function (b) { b.classList.remove("is-active"); });
          group.querySelectorAll(".qol-accordion-panel").forEach(function (p) { p.classList.remove("is-open"); p.style.maxHeight = null; });
        }

        button.classList.toggle("is-active", willOpen);
        if (panel) {
          panel.classList.toggle("is-open", willOpen);
          panel.style.maxHeight = willOpen ? panel.scrollHeight + "px" : null;
        }
      });

      group.querySelectorAll(".qol-accordion-panel.is-open, .qol-faq-panel.is-open").forEach(function (panel) {
        panel.style.maxHeight = panel.scrollHeight + "px";
      });
    });
  }

  function initFixedCart(root) {
    var fixed = document.querySelector("[data-fixed-cart]");
    var addButton = root.querySelector("[data-add-to-cart]");
    var fixedButton = document.querySelector("[data-fixed-add]");
    var form = root.querySelector("form");
    if (!fixed || !addButton || !form) return;

    if ("IntersectionObserver" in window) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          fixed.classList.toggle("is-active", !entry.isIntersecting && addButton.getBoundingClientRect().bottom < 0);
        });
      });
      observer.observe(addButton);
    }

    if (fixedButton) {
      fixedButton.addEventListener("click", function () {
        addButton.click();
      });
    }
  }

  function initAjaxAdd(root) {
    var form = root.querySelector(".qol-product-form");
    if (!form) return;
    form.addEventListener("submit", function (event) {
      var button = form.querySelector("[data-add-to-cart]");
      if (button) button.textContent = "Adding...";
    });
  }

  function initProduct() {
    var root = document.querySelector("[data-product-root]");
    if (!root) return;
    initGallery(root);
    initQuantity(root);
    initPurchaseBox(root);
    initFixedCart(root);
    initAjaxAdd(root);
  }

  function showAddToast(cart, state) {
    var toast = document.querySelector("[data-qol-add-toast]");
    if (!toast) {
      toast = document.createElement("aside");
      toast.className = "qol-add-toast";
      toast.setAttribute("data-qol-add-toast", "");
      toast.setAttribute("role", "status");
      toast.setAttribute("aria-live", "polite");
      toast.innerHTML = [
        '<button class="qol-add-toast__close" type="button" aria-label="Close">x</button>',
        '<strong>Added to cart</strong>',
        '<span>Your order is ready to review before secure checkout.</span>',
        '<div>',
        '<a class="qol-btn qol-add-toast__checkout" href="/checkout">Checkout now</a>',
        '<a class="qol-add-toast__cart" href="/cart">Edit cart</a>',
        '</div>'
      ].join("");
      document.body.appendChild(toast);
      toast.querySelector(".qol-add-toast__close").addEventListener("click", function () {
        toast.classList.remove("is-visible");
      });
    }
    toast.querySelector("strong").textContent = state === "pending" ? "Adding to cart" : state === "error" ? "Cart update paused" : "Added to cart";
    var count = cart && cart.item_count ? cart.item_count : "";
    if (state === "pending") {
      toast.querySelector("span").textContent = "One moment. Your checkout options will be ready shortly.";
    } else if (state === "error") {
      toast.querySelector("span").textContent = "Opening the standard cart so you can continue checkout.";
    } else if (count) {
      toast.querySelector("span").textContent = count + " item" + (count > 1 ? "s" : "") + " in cart. Review your order before secure checkout.";
    }
    window.setTimeout(function () { toast.classList.add("is-visible"); }, 50);
  }

  function initGlobalAddToCart() {
    document.addEventListener("submit", function (event) {
      var form = event.target;
      if (!form || !form.matches || !form.matches('form[action*="/cart/add"]') || form.classList.contains("qol-product-form")) return;
      if (!window.fetch) return;
      event.preventDefault();
      var button = form.querySelector("button[type='submit']");
      var original = button ? button.textContent : "";
      if (button) {
        button.disabled = true;
        button.textContent = "Adding...";
      }
      showAddToast(null, "pending");
      fetch("/cart/add.js", {
        method: "POST",
        headers: { "Accept": "application/json" },
        body: new FormData(form)
      })
        .then(function (response) {
          if (!response.ok) throw new Error("Add failed");
          return response.json();
        })
        .then(function (item) {
          var currentCount = parseInt((document.querySelector(".qol-cart-count") || {}).textContent || "0", 10) || 0;
          var nextCount = currentCount + (item && item.quantity ? item.quantity : 1);
          document.querySelectorAll(".qol-cart-count").forEach(function (el) { el.textContent = nextCount; });
          if (button) button.textContent = "Added";
          showAddToast({ item_count: nextCount });
          setTimeout(function () {
            if (button) {
              button.disabled = false;
              button.textContent = original;
            }
          }, 1200);
        })
        .catch(function () {
          showAddToast(null, "error");
          form.submit();
        });
    }, true);
  }

  function initBackButtons() {
    document.querySelectorAll("[data-qol-back]").forEach(function (button) {
      button.addEventListener("click", function () {
        if (document.referrer && document.referrer.indexOf(location.host) !== -1 && history.length > 1) {
          history.back();
        } else {
          location.href = "/collections/all";
        }
      });
    });
  }

  function initRecentlyViewed() {
    var root = document.querySelector("[data-product-root]");
    if (root) {
      var title = document.querySelector(".qol-product-summary h1");
      var image = document.querySelector(".qol-gallery-slide.is-active img");
      var price = document.querySelector(".qol-price__sale");
      if (title && image) {
        var item = {
          title: title.textContent.trim(),
          url: location.pathname,
          image: image.currentSrc || image.src,
          price: price ? price.textContent.trim() : ""
        };
        var saved = [];
        try { saved = JSON.parse(localStorage.getItem("qol_recent") || "[]"); } catch (error) { saved = []; }
        saved = saved.filter(function (old) { return old.url !== item.url; });
        saved.unshift(item);
        localStorage.setItem("qol_recent", JSON.stringify(saved.slice(0, 6)));
      }
    }

    var target = document.querySelector(".qol-cart-page, .qol-product-template, .qol-collection-page");
    if (!target || document.querySelector(".qol-recent-panel")) return;
    var recent = [];
    try { recent = JSON.parse(localStorage.getItem("qol_recent") || "[]"); } catch (error) { recent = []; }
    recent = recent.filter(function (item) { return item && item.url && item.title && item.image && item.url !== location.pathname; }).slice(0, 4);
    if (!recent.length) return;
    var panel = document.createElement("section");
    panel.className = "qol-recent-panel qol-container";
    panel.innerHTML = '<div class="qol-recent-panel__head"><h2>Recently viewed</h2><a href="/collections/all">View all</a></div><div class="qol-recent-panel__grid">' +
      recent.map(function (item) {
        return '<a href="' + item.url + '"><img src="' + item.image + '" alt=""><span><strong>' + item.title + '</strong><small>' + item.price + '</small></span></a>';
      }).join("") + '</div>';
    target.insertAdjacentElement("afterend", panel);
  }

  function initPeopleTalking() {
    document.querySelectorAll("[data-people-slider]").forEach(function (slider) {
      var slides = Array.prototype.slice.call(slider.querySelectorAll("[data-people-slide]"));
      var dots = Array.prototype.slice.call(slider.querySelectorAll("[data-people-dot]"));
      if (slides.length < 2 || !dots.length) return;
      var active = slides.findIndex(function (slide) { return slide.classList.contains("is-active"); });
      if (active < 0) active = 0;
      var timer;

      function show(index) {
        active = (index + slides.length) % slides.length;
        slides.forEach(function (slide, slideIndex) {
          slide.classList.toggle("is-active", slideIndex === active);
        });
        dots.forEach(function (dot, dotIndex) {
          dot.classList.toggle("is-active", dotIndex === active);
          dot.setAttribute("aria-selected", String(dotIndex === active));
        });
      }

      function start() {
        stop();
        timer = window.setInterval(function () { show(active + 1); }, 5200);
      }

      function stop() {
        if (timer) window.clearInterval(timer);
      }

      dots.forEach(function (dot, dotIndex) {
        dot.addEventListener("click", function () {
          show(dotIndex);
          start();
        });
      });
      slider.addEventListener("mouseenter", stop);
      slider.addEventListener("mouseleave", start);
      show(active);
      start();
    });
  }

  function initVideoPage() {
    var grid = document.querySelector("[data-video-grid]");
    if (grid) {
      var cards = Array.prototype.slice.call(grid.querySelectorAll("[data-video-card]"));
      var loadButton = document.querySelector("[data-load-videos]");
      if (loadButton) {
        loadButton.addEventListener("click", function () {
          var hidden = cards.filter(function (card) { return card.classList.contains("is-hidden"); });
          hidden.slice(0, 6).forEach(function (card) { card.classList.remove("is-hidden"); });
          if (cards.every(function (card) { return !card.classList.contains("is-hidden"); })) {
            loadButton.style.display = "none";
          }
        });
      }
    }

    var modal = document.querySelector("[data-video-modal]");
    if (!modal) return;
    var frame = modal.querySelector("[data-video-frame]");
    var close = modal.querySelector("[data-video-close]");

    function closeModal() {
      modal.hidden = true;
      if (frame) frame.innerHTML = "";
      document.body.classList.remove("qol-video-open");
    }

    document.querySelectorAll("[data-video-open]").forEach(function (link) {
      link.addEventListener("click", function (event) {
        var href = link.getAttribute("href");
        if (!href || !frame) return;
        event.preventDefault();
        var isMp4 = href.toLowerCase().indexOf(".mp4") !== -1;
        frame.innerHTML = isMp4
          ? '<video src="' + href + '" controls autoplay playsinline></video>'
          : '<iframe src="' + href + '" allow="autoplay; encrypted-media; picture-in-picture" allowfullscreen title="Quality of Life video"></iframe>';
        modal.hidden = false;
        document.body.classList.add("qol-video-open");
      });
    });

    if (close) close.addEventListener("click", closeModal);
    modal.addEventListener("click", function (event) {
      if (event.target === modal) closeModal();
    });
    document.addEventListener("keydown", function (event) {
      if (event.key === "Escape" && !modal.hidden) closeModal();
    });
  }

  function initQolChat() {
    var chat = document.querySelector("[data-qol-chat]");
    var panel = chat && chat.querySelector("[data-qol-chat-panel]");
    var messages = chat && chat.querySelector("[data-qol-chat-messages]");
    var form = chat && chat.querySelector("[data-qol-chat-form]");
    var input = chat && chat.querySelector("#qol-chat-input");
    if (!chat || !panel || !messages || !form || !input) return;
    chat.hidden = false;

    var answers = [
      { match: ["ship", "delivery", "deliver", "postage", "free"], answer: "Free shipping is available on all orders. The final shipping charge is shown as $0.00 before payment at checkout." },
      { match: ["return", "refund", "exchange", "money back"], answer: "Eligible returns can be requested within 30 days of delivery. Please contact our team with your order number before sending anything back." },
      { match: ["how to use", "use", "dose", "dosage", "take", "capsule", "vegicap"], answer: "Please follow the suggested use on the product label. If you take medication, have a medical condition, or are pregnant or nursing, consult a qualified healthcare professional before use." },
      { match: ["safe", "secure", "payment", "checkout", "credit card", "paypal"], answer: "Checkout is handled through Shopify's secure checkout. Payment details are encrypted, and the available payment methods are shown before you place the order." },
      { match: ["ahcc", "immune", "immunity", "mushroom", "ingredient", "work"], answer: "AHCC® Kinoko® Platinum is a dietary supplement made with a proprietary mushroom mycelia extract for an immune-support routine. It is not a medicine and is not intended to diagnose, treat, cure, or prevent disease." },
      { match: ["subscribe", "subscription", "autoship", "refill"], answer: "Subscribe & Save options, when available, show the delivery frequency and price before checkout. Please review those details before placing the order." },
      { match: ["order", "tracking", "track", "where is", "status"], answer: "For an order update, please contact our team with your order number and the email used at checkout. We will help check the latest status." }
    ];

    function getAnswer(question) {
      var normalized = String(question || "").toLowerCase().replace(/[^a-z0-9\s]/g, " ");
      var intent = answers.find(function (entry) { return entry.match.some(function (term) { return normalized.indexOf(term) !== -1; }); });
      return intent ? intent.answer : "I can help with AHCC, shipping, returns, how to use the product, subscriptions, secure checkout, and order updates. For anything else, our team can help directly.";
    }

    function addMessage(text, type) {
      var message = document.createElement("div");
      message.className = "qol-chat__message qol-chat__message--" + type;
      message.textContent = text;
      messages.appendChild(message);
      messages.scrollTop = messages.scrollHeight;
    }

    function ask(question) {
      var cleanQuestion = String(question || "").trim();
      if (!cleanQuestion) return;
      addMessage(cleanQuestion, "user");
      input.value = "";
      window.setTimeout(function () { addMessage(getAnswer(cleanQuestion), "bot"); }, 180);
    }

    function setOpen(open) {
      panel.hidden = !open;
      var toggle = chat.querySelector("[data-qol-chat-toggle]");
      if (toggle) toggle.setAttribute("aria-expanded", String(open));
      if (open) window.setTimeout(function () { input.focus(); }, 0);
    }

    chat.addEventListener("click", function (event) {
      if (event.target.closest("[data-qol-chat-toggle]")) { setOpen(panel.hidden); return; }
      if (event.target.closest("[data-qol-chat-close]")) { setOpen(false); return; }
      var quickReply = event.target.closest("[data-qol-chat-question]");
      if (quickReply) ask(quickReply.getAttribute("data-qol-chat-question"));
    });
    form.addEventListener("submit", function (event) { event.preventDefault(); ask(input.value); });
    document.addEventListener("keydown", function (event) { if (event.key === "Escape" && !panel.hidden) setOpen(false); });
  }

  document.documentElement.classList.remove("no-js");
  document.addEventListener("DOMContentLoaded", function () {
    initHeader();
    initGlobalAddToCart();
    initBackButtons();
    initProduct();
    initAccordions(document);
    initPeopleTalking();
    initVideoPage();
    initRecentlyViewed();
    initQolChat();
  });
})();



(function () {
  function formatCents(cents) {
    if (window.Shopify && typeof window.Shopify.formatMoney === "function") {
      return window.Shopify.formatMoney(cents);
    }
    return "$" + (Number(cents || 0) / 100).toFixed(2);
  }

  function initQuantityOffers() {
    document.querySelectorAll("[data-quantity-offers]").forEach(function (wrap) {
      var productRoot = wrap.closest("[data-product-root]");
      var quantityInput = productRoot ? productRoot.querySelector("[data-quantity-input]") : document.querySelector("[data-quantity-input]");
      var buttons = wrap.querySelectorAll("[data-offer-qty]");

      wrap.querySelectorAll("[data-offer-price]").forEach(function (node) {
        var unit = parseInt(node.getAttribute("data-unit-price") || "0", 10);
        var qty = parseInt(node.getAttribute("data-qty") || "1", 10);
        var discount = parseFloat(node.getAttribute("data-discount") || "0");
        var total = Math.round(unit * qty * (1 - discount / 100));
        node.textContent = formatCents(total);
      });

      buttons.forEach(function (button) {
        button.addEventListener("click", function () {
          buttons.forEach(function (item) { item.classList.remove("is-selected"); });
          button.classList.add("is-selected");
          if (quantityInput) {
            quantityInput.value = button.getAttribute("data-offer-qty") || "1";
            quantityInput.dispatchEvent(new Event("change", { bubbles: true }));
          }
        });
      });
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initQuantityOffers);
  } else {
    initQuantityOffers();
  }
})();
